<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>

<div class="row mt-4" *ngIf="!loading">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-6 mr-auto">
        <h3>Subscription Performance Report</h3>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row" *ngIf="!loading">
  <div class="col">
    Total Results: {{totalItems}}
  </div>
  <div class="col text-right align-self-end">
    <div class="form-check form-check-inline align-middle">
      <input class="form-check-input text-dark" type="checkbox" id="checkbox" [(ngModel)]="hiddenFlag">
      <label class="form-check-label text-dark font-weight-bold" for="checkbox">Hidden Zero</label>
    </div>
    <button class="btn btn-danger btn-sm mr-2" (click)="close()">Close</button>
  </div>
</div>
<div class="table-responsive" *ngIf="!loading">
  <table id="subList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
    <thead>
      <tr>
        <th class="align-middle" rowspan="2" >ShortCode</th>
        <th class="align-middle" rowspan="2" >Keyword</th>
        <th class="align-middle" rowspan="2" >Operator</th>
        <th class="align-middle" rowspan="2" >Affiliate</th>
        <th class="align-middle" rowspan="2" >Client</th>
        <th class="align-middle" rowspan="2" >Share</th>
        <th class="align-middle" rowspan="2" >SpiderAccount</th>
        <th [attr.colspan]="subsReportLength">Reports</th>
      </tr>
      <tr>
        <th *ngFor="let rep of reports">{{rep.day}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let sub of subscriptions; index as i; ">
        <ng-container *ngIf="isDisplay(sub.allZero)">
          <td>{{sub.shortCode}}</td>
          <td>{{sub.keyword}}</td>
          <td>{{sub.operator}}</td>
          <td>{{sub.affiliate}}</td>
          <td>{{sub.client}}</td>
          <td>{{sub.share}}</td>
          <td>{{sub.spiderAccount}}</td>
          <td align="right" *ngFor="let rep of sub.reports">{{rep.count}}</td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>

